/**
 * バンドルミックスマッチ設定画面　成立価格算出VOクラス
 */
export class KYMW1308CalcApprovedPriceModel {
  /** 値引率 */
  public discountPercent = NaN;
  /** 値引商品リスト */
  public discountGoodsList: Array<any> = new Array<any>();

}
